import { errorHandler } from "./errorHandler";

const reportReactError = (type, error, errorInfo) =>
	errorHandler(error, {
		extra: {
			type,
			componentStack: errorInfo?.componentStack,
			digest: errorInfo?.digest,
		},
	});

const createHandler = (type) => (error, errorInfo) => {
	reportReactError(type, error, errorInfo);
};

export const reactErrorHandlers = {
	onCaughtError: createHandler("caught"),
	onRecoverableError: createHandler("recoverable"),
	onUncaughtError: createHandler("uncaught"),
};
